import { Link } from 'react-router-dom';
import './Nosotros.css';

const Nosotros = () => {
  return (
    <div className="nosotros-container">
      <section className="nosotros-intro">
        <h2>Sobre Nosotros</h2>
        <p>
          En <strong>Al-Andalus Feeling</strong>, ayudamos a las empresas a sacar el máximo rendimiento de su ERP Sage 200. No vendemos el software; nos especializamos en su implementación, personalización y mejora a través de formación, desarrollos a medida y soluciones web y móviles integradas con la plataforma.
        </p>
        <p>
          Nuestra experiencia en gestión de producción, proyectos y finanzas nos permite ofrecer un enfoque estructurado y eficiente. Desarrollamos planes de implementación personalizados, con entregas por hitos, asegurando que cada cliente pueda adoptar la tecnología de manera ágil y sin afectar su operativa diaria.
        </p>
      </section>

      <section className="nosotros-diferentes">
        <h3>¿Qué nos hace diferentes?</h3>
        <ul>
          <li><strong>Planes a medida:</strong> Nos adaptamos a las necesidades específicas de cada empresa, asegurando una integración eficiente y optimizada.</li>
          <li><strong>Asistencia y soporte continuo:</strong> Ofrecemos consultoría especializada y asistencia remota mediante centralita y ticketing, garantizando un servicio ágil y eficaz.</li>
          <li><strong>Equipo altamente cualificado:</strong> Contamos con certificación en todos los módulos de Sage 200, además de expertos en desarrollo web y app.</li>
        </ul>
      </section>

      <section className="nosotros-historia">
        <h3>Nuestra Historia y Valores</h3>
        <p>
          Nuestra empresa nació con un propósito claro: ayudar a las empresas a aprovechar al máximo Sage 200. Sabemos que muchas organizaciones no utilizan todo el potencial del ERP por falta de formación o personalización. En Al-Andalus Feeling, facilitamos ese camino, garantizando que cada módulo y desarrollo esté alineado con los objetivos del negocio.
        </p>
        <p>
          Trabajamos a nivel nacional, ofreciendo soporte a cualquier empresa que utilice Sage 200. Nuestros valores se centran en la transparencia, la cercanía y la excelencia en el servicio. No solo implementamos soluciones, sino que acompañamos a nuestros clientes en su evolución tecnológica, ayudándolos a resolver dudas, mejorar procesos y encontrar nuevas oportunidades de crecimiento.
        </p>
      </section>

      <section className="nosotros-servicios">
        <h3>Servicios que Ofrecemos</h3>
        <ul>
          <li>Implementación y formación en Sage 200</li>
          <li>Desarrollos a medida dentro de Sage 200</li>
          <li>Integraciones con aplicaciones web y móviles</li>
          <li>Consultoría especializada en producción, proyectos y finanzas</li>
          <li>Asistencia técnica y soporte remoto</li>
        </ul>
      </section>

      <section className="nosotros-compromiso">
        <h3>Compromiso</h3>
        <p>
          En Al-Andalus Feeling, estamos comprometidos con el éxito de nuestros clientes. Si buscas un equipo de expertos que te ayude a potenciar el uso de Sage 200 en tu negocio, estamos listos para acompañarte en el proceso.
        </p>
        <Link to="/contacto" className="btn-contacto">
          Contáctanos
        </Link>
      </section>

      {/* Imagen de fondo */}
      <div className="nosotros">
        <div className="nosotros-background">
          <img 
            src="/images/Nosotros.jpg" 
            alt="Imagen de fondo de contacto" 
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  );
};

export default Nosotros;
